import React from "react";
import Navigation from "../components/Navigation/Navigation";
import { FaFacebookSquare, FaInstagramSquare } from "react-icons/fa";
import { MdAlternateEmail } from "react-icons/md";

const Kontakt = () => {
	return (
		<>
			{/* Navigeringsmeny inlänkad */}
			<Navigation />
			{/* Applikationens innehåll börjar */}
			<h1>Kontakt</h1>
			<div className="main">
				<section className="wrapper wrapper_kontakt">
					<h3>Kontaktinformation</h3>
					<br />
					<p>
						Har du någon fråga om katter, något kattbild eller liknade som du vill dela med
						dig av? Tveka inte att kontakta oss via mail eller någon av de sociala medier som
						vi använder oss av. Vi svara er så snart vi har möjlighet.
					</p>
					<br />
					<p>
						<strong>
							Mail
							<MdAlternateEmail size={40} />:
						</strong>{" "}
						alltomkatter@net.com
					</p>
					<p>
						<strong>Facebook:</strong>{" "}
						<a href="https://www.facebook.com/" target="_blank">
							<FaFacebookSquare className="icon" size={40} />
						</a>
					</p>
					<p>
						<strong>Instagram:</strong>{" "}
						<a href="https://www.instagram.com/" target="_blank">
							{" "}
							<FaInstagramSquare className="icon" size={40} />
						</a>
					</p>
					<br />

					<div className="polaroid rotate_right center">
						<img
							src="./bilder/sociala_medier.png"
							alt="Allt om katter på en ipad"
							className="responsive katt katt_1 sm center"
						/>

						<br />
						<br />
						<div className="fotopile">
							<img
								src="./bilder/katt_blunda.jpg"
								alt="Söt katt som sover"
								className="responsive katt katt_1"
							/>
							<img
								src="./bilder/katt_rygg.jpg"
								alt="Söt som sover"
								className="responsive katt katt_1 bildkontakt"
							/>
						</div>
						<div class="polaroid rotate_left">
							<img
								src="./bilder/sov_katt.jpg"
								alt="Söt sovande katt"
								className="responsive katt katt_1 center"
							/>
						</div>
					</div>
				</section>
			</div>
		</>
	);
};

export default Kontakt;
